export { default } from "./geospatialWidget";
